let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dKBuH")).then(() => parcelRequire('fzD7h'));